import { BoxProps } from '@procore/core-react/dist/_typedoc/Box/Box.types.json';
import * as React from 'react';
export default {
  BoxProps,
  React
};